"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var WEBLAB_COOKIE_KEY = 'experiment';
/**
 * Parses the weblab cookie into a map of weblab id to treatment. A weblab
 * cookie is of the form `<weblabId1>:<treatment1>&<weblabId2>:<treatment2>`.
 *
 * [NeoWeblab](https://w.amazon.com/index.php/NeoWeblab) surrounds the cookie
 * string in double quotes, these are also accounted for.
 *
 * @param cookie The weblab cookie to parse.
 * @return A mapping from weblab id to treatment.
 */
function parseWeblabCookie(cookie) {
    if (!cookie) {
        return {};
    }
    var assignments = cookie
        // https://issues.amazon.com/KAT-2159
        .replace(/["']/g, '')
        .split('&');
    return assignments.reduce(function (values, mapping) {
        var _a;
        var _b = mapping.split(':'), weblabId = _b[0], treatment = _b[1];
        return !weblabId || !treatment
            ? values
            : __assign(__assign({}, values), (_a = {}, _a[weblabId.trim()] = treatment.trim(), _a));
    }, {});
}
exports.parseWeblabCookie = parseWeblabCookie;
/**
 * Reads & parses the weblab cookie from the browser's cookies.
 * If the cookie doesn't exist, an empty map will be returned.
 * @return The parsed weblab/treatment map.
 */
function readWeblabCookie() {
    var cookie = readCookie(WEBLAB_COOKIE_KEY);
    if (!cookie) {
        return {};
    }
    return parseWeblabCookie(cookie);
}
exports.readWeblabCookie = readWeblabCookie;
/**
 * Reads a cookie by name from the browser's cookies if available.
 * @see https://stackoverflow.com/a/25490531/2451889
 * @param name The cookie to read.
 * @return The cookie's value, or undefined if the cookie is not set.
 */
function readCookie(name) {
    if (typeof document === 'undefined' ||
        typeof document.cookie === 'undefined') {
        return undefined;
    }
    var match = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : undefined;
}
exports.readCookie = readCookie;
